module.exports = __webpack_public_path__ + "static/images/ui/ui-icons_222222_256x240.png";